import { render, staticRenderFns } from "./ValidatedMultiselect.vue?vue&type=template&id=1cb4c97b&scoped=true&"
import script from "./ValidatedMultiselect.vue?vue&type=script&lang=js&"
export * from "./ValidatedMultiselect.vue?vue&type=script&lang=js&"
import style0 from "./ValidatedMultiselect.vue?vue&type=style&index=0&id=1cb4c97b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cb4c97b",
  null
  
)

export default component.exports